<template>
  <i-menu
    ref="menu"
    @on-select="selectHandler"
    class="profile-menu"
    mode="horizontal"
    theme="dark"
  >
    <payments-control-button v-if="$store.getters.hasModule('payment_distribution')" />
    <notifications />
    <active-tasks />
    <user-feedback />

    <submenu name="4" trigger="click">
      <template slot="title">
        {{ getName() }}
        <avatar
          v-if="user.avatar_resource_id"
          class="user-avatar"
          size="small"
          :src="`${mainUrl}/api/download_resource/${user.avatar_resource_id}?access_token=${token}`"
        />
        <avatar v-else class="user-avatar" size="small" icon="ios-person" />
      </template>
      <menu-group :title="getPosition(user)">
        <menu-item name="theme">
          <div class="profile-menu__item">
            <span>
              {{ theme === "dark" ? "Темная тема" : "Светлая тема" }}
            </span>
            <icon :type="theme === 'dark' ? 'md-moon' : 'md-sunny'" />
          </div>
        </menu-item>
        <router-link class="ivu-menu-item" to="/app/profile">
          <div class="profile-menu__item">
            <span>
              Профиль
            </span>
            <icon type="md-person" />
          </div>
        </router-link>
        <a class="ivu-menu-item" href="https://offers.inj-geo.ru/docs/" target="_blank">
          <div class="profile-menu__item">
            <span>
              Документация
            </span>
            <icon type="md-help-circle" />
          </div>
        </a>
        <!-- <menu-item name="about">
          <div class="profile-menu__item">
            <span>
              О системе
            </span>
            <icon type="md-information-circle" />
          </div>
        </menu-item> -->
      </menu-group>
      <divider />
      <menu-item name="logout">
        <div class="profile-menu__item">
          <span>
            Выйти
          </span>
          <icon type="md-exit" />
        </div>
      </menu-item>
    </submenu>
  </i-menu>
</template>

<script>
import Notifications from '@/components/notifications/notifications'
import ActiveTasks from '@/components/active-tasks/active-tasks'
import PaymentsControlButton from '@/components/payments-control/payments-control-button'
import UserFeedback from '@/components/feedback/user-feedback'
import { toggleTheme } from '@/utils'
import { mainUrl } from '@/config/urls'

export default {
  components: {
    Notifications,
    ActiveTasks,
    PaymentsControlButton,
    UserFeedback
  },
  data () {
    return {
      mainUrl,
      user: this.$store.state.auth.user,
      token: this.$store.state.auth.token,
      activeMenu: ''
    }
  },
  computed: {
    theme () {
      return this.$store.state.theme
    }
  },
  methods: {
    async logout () {
      await this.$store.dispatch('AUTH_LOGOUT')

      // this.$router.push('/login')
    },
    getName () {
      const user = this.$store.state.auth.user || {}
      const { first_name, username } = user
      return first_name ? `${first_name}` : username
    },
    selectHandler (name) {
      switch (name) {
        case 'logout':
          return this.logout()
        case 'theme':
          const theme = this.theme === 'dark' ? 'light' : 'dark'
          toggleTheme(theme)
          return this.$store.commit('SET_THEME', theme)
        case 'about':
          this.$store.commit('SET_ABOUT_MODAL', true)
      }
    },
    getPosition (user) {
      return user.position.name
    }
  }
}
</script>

<style lang="less">
.profile-menu {
  &.ivu-menu {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    font-size: 12px;

    &.ivu-menu-horizontal {
      height: 40px;
      line-height: 40px;

      .ivu-menu-item {
        font-size: 12px;

        i {
          margin-right: 0;
        }
      }
      .ivu-menu-submenu {
        padding-left: 8px;
        padding-right: 0;

        .ivu-select-dropdown {
          width: 180px !important;

          .ivu-menu-item-group-title {
            height: auto;
            line-height: 1.5;
            padding: 8px 16px;
          }

          .ivu-menu-item {
            font-size: 12px !important;
          }
        }

        .ivu-menu-submenu-title > i,
        .ivu-menu-submenu-title span > i {
          margin-right: 0;
        }
      }
    }
  }
  .user-avatar {
    margin-left: 5px;
  }

  .ivu-divider-horizontal {
    margin: 0;
    top: 0;
  }
  .ivu-menu-drop-list {
    min-width: 140px;
  }

  .ivu-badge-dot {
    top: 6px;
    right: -6px;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
